var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('canvas',{ref:"canvas",attrs:{"id":"canvas"}}),_c('div',{staticClass:"countdown",style:({
      width: (100 * _vm.blocked / _vm.blockDuration) + '%'
    })}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.blocked > 0),expression:"blocked > 0"}],staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }